import { useGlobal } from '@/utils/useGlobal';
import Nav from './components/Nav';
import styles from './index.module.scss';
import { getProductData } from '@elem/utils/getProductData';
import { useEffect, useState } from 'react';
import { getProductFromGeneralKey } from '@/utils/productGetServerSideProps';
import { generalKey } from './config/pageConfig';
import ProductSpecs from '@elem/compCommon/ProductConstructor/Specs';

const Specs = () => {
    const { useRouter, gloproductlist } = useGlobal();

    const { locale } = useRouter();

    const productMsg = getProductFromGeneralKey({ gloproductlist, generalKey });

    const [productDataA, setProductDataA] = useState<any>(null);

    const getProductDataHandle = async () => {
        const productPageData = await getProductData(productMsg, locale);
        setProductDataA(productPageData);
    };

    useEffect(() => {
        getProductDataHandle();
    }, []);

    return (
        <div className={styles.FAQ}>
            <Nav theme="white" />
            {productDataA && <ProductSpecs productCatagory={productDataA.productCatagory} productDetail={productDataA.productDetail} theme="white" />}
        </div>
    );
};

export default Specs;
